import { CONTACT_BANNER } from "../../strings/HomePage"
import { BUTTON_TEXTS, EMPTY_STRING, TOASTER_MESSAGE, TOASTER_THEME, TOASTER_TYPE } from "../../strings/Strings"
import ReponsiveButton from "../ui_elements/button/ButtonNew"

import cx from 'classnames';
import classes from './ContactBanner.module.css';
import { BUTTON_TYPES } from "../../utils/ButtonConstants";
import { IMAGES } from "../../utils/ImageConstants"
import TextField from "../ui_elements/form_fields/text_input/TextField"
import { isEmpty, isEmptyObject, isValidCompanyNameString, isValidJobTitleString, isValidMobileNumber, isValidNameString, isValidWorkEmailString } from "../../utils/UtilityFunctions"
import { useEffect, useState } from "react"
import PhoneField from "../ui_elements/form_fields/text_phone_number/PhoneField"
import { POST_CONTACT } from "../../urls/Urls"
import axios from "axios"
import { toast } from "react-toastify"

function ContactBanner(props) {

    let { isAuthenticated, userDetails } = props
    
    const [formValues,setFormValues] = useState({});
    const [formErrors,setFormErrors] = useState({});
    const [isFormSubmitting,setIsFormSubmitting] = useState(false);
    const [isErrorSubmitting,setIsErrorSubmitting] = useState(false);

    useEffect(() => {
        if(isAuthenticated && !isEmptyObject(userDetails)) {
            let newFormValues = {}
            newFormValues["name"] = userDetails.displayName
            newFormValues["email"] = userDetails.email
            newFormValues["company"] = userDetails.companyName
            newFormValues["jobtitle"] = userDetails.jobTitle
            setFormValues(newFormValues)
        }
    },[isAuthenticated,userDetails])

    let buttonGroupComponent = null;

    const onClickSubmitHandler = () => {
        let newErrorValues = {}
        newErrorValues["name"] = isValidNameString(formValues?.name,true).error;
        newErrorValues["email"] = isValidWorkEmailString(formValues?.email,true).error;
        newErrorValues["phone"] = isValidMobileNumber(formValues?.phoneNormal,formValues?.phoneData,formValues?.phone,true).error;
        newErrorValues["jobtitle"] = isValidJobTitleString(formValues?.jobtitle,true).error;
        newErrorValues["company"] = isValidCompanyNameString(formValues?.company,true).error;

        let isSubmitError = Object.keys(newErrorValues).filter(key => newErrorValues[key])

        if (!isSubmitError.length) {
            setIsFormSubmitting(true)
            let url = POST_CONTACT;
            let data = {
                name: formValues?.name,
                job_title: formValues?.jobtitle,
                email: formValues?.email,
                phone: formValues?.phone,
                company: formValues?.company
            }
            axios.post(url, data)
                .then(res => {
                    setFormValues({})
                    setFormErrors({})
                    
                    toast(TOASTER_MESSAGE.CONTACT_US.SUCCESS,
                        {
                            type: TOASTER_TYPE.SUCCESS,
                            theme: TOASTER_THEME.LIGHT
                        });
                })
                .catch(err => {
                    console.log("[Error] : ",err.message)
                    toast(TOASTER_MESSAGE.CONTACT_US.ERROR,
                        {
                            type: TOASTER_TYPE.ERROR,
                            theme: TOASTER_THEME.LIGHT
                        });
                })
                .finally(() => {
                    setIsFormSubmitting(false)
                    setIsErrorSubmitting(false)
                })
        } else {
            setFormErrors(newErrorValues)
            setIsFormSubmitting(false)
            setIsErrorSubmitting(true)
        }
    }

    const onChangeName = (name) => {
        let newFormValues = Object.assign({},formValues)
        newFormValues["name"] = name

        let newFormErrors = Object.assign({},formErrors)
        newFormErrors["name"] = false

        setFormValues(newFormValues)
        setFormErrors(newFormErrors)
    }

    const onChangeCompanyName = (companyname) => {
        let newFormValues = Object.assign({},formValues)
        newFormValues["company"] = companyname

        let newFormErrors = Object.assign({},formErrors)
        newFormErrors["company"] = false

        setFormValues(newFormValues)
        setFormErrors(newFormErrors)
    }

    const onChangeJobTitle = (jobtitle) => {
        let newFormValues = Object.assign({},formValues)
        newFormValues["jobtitle"] = jobtitle

        let newFormErrors = Object.assign({},formErrors)
        newFormErrors["jobtitle"] = false

        setFormValues(newFormValues)
        setFormErrors(newFormErrors)
    }

    const onChangeEmail = (email) => {
        let newFormValues = Object.assign({},formValues)
        newFormValues["email"] = email

        let newFormErrors = Object.assign({},formErrors)
        newFormErrors["email"] = false

        setFormValues(newFormValues)
        setFormErrors(newFormErrors)
    }

    const onChangePhone = (phone,data,formatted) => {
        let newFormValues = Object.assign({},formValues)
        newFormValues["phone"] = formatted
        newFormValues["phoneData"] = data
        newFormValues["phoneNormal"] = phone

        let newFormErrors = Object.assign({},formErrors)
        newFormErrors["phone"] = false

        setFormValues(newFormValues)
        setFormErrors(newFormErrors)
    }
    
    buttonGroupComponent = (
        <ReponsiveButton
            label={BUTTON_TEXTS.CONTACT_US}
            containerClass={"col-12"}
            id={"Contact-Try-It-Button"}
            actionType={BUTTON_TYPES.ACTIONS.PRIMARY}
            radiusType={BUTTON_TYPES.RADIUS.ROUND_RECTANGLE}
            borderType={BUTTON_TYPES.BORDER.NO_BORDER}
            onClickHandler={onClickSubmitHandler}
            disabled={isFormSubmitting}
        />
    )

    return (
        <div className={cx(['col-12', classes.ContactUs])}>
            <div className="container py-5">
                <div className="row flex-wrap">
                    <div className={cx(["col-12 col-md-8"])}>
                        <h2 className={classes.ContactHeadText}>{CONTACT_BANNER.UNSUBSCRIBED.HEADING}</h2>
                        <p className={classes.SupportText}>
                            {CONTACT_BANNER.UNSUBSCRIBED.SUB_TEXT}
                        </p>
                        <div className="col-12 col-sm-10 col-lg-8 row flex-wrap mt-4">
                            <div className="col-12">
                                <TextField
                                    containerClass='col-12'
                                    value={formValues?.name || EMPTY_STRING}
                                    id={'name'}
                                    placeHolder={"Type your name here..."}
                                    onChangeHandler={onChangeName}
                                    validate={isValidNameString}
                                    isDisabled={isFormSubmitting} 
                                    isReadOnly={isFormSubmitting}
                                    isError={isErrorSubmitting}
                                    isFieldError={formErrors?.name || false}
                                    isMandatory={true} 
                                    isNumber={false}
                                />
                            </div>
                            <div className="col-6">
                                <TextField
                                    containerClass='col-12'
                                    value={formValues?.company || EMPTY_STRING}
                                    id={'companyname'}
                                    placeHolder={"Type your company name here..."}
                                    onChangeHandler={onChangeCompanyName}
                                    validate={isValidCompanyNameString}
                                    isDisabled={isFormSubmitting} 
                                    isReadOnly={isFormSubmitting}
                                    isError={isErrorSubmitting}
                                    isFieldError={formErrors?.company || false}
                                    isMandatory={true} 
                                    isNumber={false}
                                />
                            </div>
                            <div className="col-6">
                                <TextField
                                    containerClass='col-12'
                                    value={formValues?.jobtitle || EMPTY_STRING}
                                    id={'jobtitle'}
                                    placeHolder={"Type your job title here..."}
                                    onChangeHandler={onChangeJobTitle}
                                    validate={isValidJobTitleString}
                                    isDisabled={isFormSubmitting} 
                                    isReadOnly={isFormSubmitting}
                                    isError={isErrorSubmitting}
                                    isFieldError={formErrors?.jobtitle || false}
                                    isMandatory={true} 
                                    isNumber={false}
                                />
                            </div>
                            <div className="col-6">
                                <TextField
                                    containerClass='col-12'
                                    value={formValues?.email || EMPTY_STRING}
                                    id={'email'}
                                    placeHolder={"Type your email ID here..."}
                                    onChangeHandler={onChangeEmail}
                                    validate={isValidWorkEmailString}
                                    isDisabled={isFormSubmitting} 
                                    isReadOnly={isFormSubmitting}
                                    isError={isErrorSubmitting}
                                    isFieldError={formErrors?.email || false}
                                    isMandatory={true} 
                                    isNumber={false}
                                />
                            </div>
                            <div className="col-6">
                                <PhoneField
                                    containerClass='col-12'
                                    value={formValues?.phone || EMPTY_STRING}
                                    isDisabled={isFormSubmitting}
                                    id={'phone'}
                                    onChangeHandler={onChangePhone}
                                    validate={isValidMobileNumber}
                                    isError = {isErrorSubmitting}
                                    isFieldError = {formErrors?.phone || false}
                                    mobileData={formValues?.phoneData || EMPTY_STRING} 
                                    mobileNormal={formValues?.phoneNormal || EMPTY_STRING}
                                    isMandatory={true}
                                />
                            </div>
                            <div className="col-6">
                                {buttonGroupComponent}
                            </div>
                        </div>
                    </div>
                    <div className={cx(["d-none d-md-block col-4"])}>
                        <div className={classes.BannerBackImage}>
                            <img src={IMAGES.PAGES.CONTACT_US_BACK} alt={"Contact Vivas.AI Team"} width={"100"} height={"100"} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ContactBanner;